// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OrderList_wrapper_3_pf2","inner":"OrderList_inner_3QYH1","orderItemMobile":"OrderList_orderItemMobile_2aydO"};